import React from 'react';
import PropTypes from 'prop-types';

function L2Button({ activeColor, color, value }) {
  return (
    <>
      <path
        d="M113.419 104.281C113.419 104.281 145.739 95.7403 163.712 92.7507C181.685 89.761 212.592 86.9925 212.592 86.9925C212.592 86.9925 202.325 44.5035 199.45 37.7641C196.575 31.0246 188.309 18.5572 178.016 13.7439C167.722 8.93056 164.451 6.01417 153.607 7.81808C142.764 9.622 129.129 18.2182 122.292 34.1865C115.455 50.1549 113.419 104.281 113.419 104.281Z"
        fill={color}
      />
      <path
        d="M113.419 104.281C113.419 104.281 145.739 95.7403 163.712 92.7507C181.685 89.761 212.592 86.9925 212.592 86.9925C212.592 86.9925 202.325 44.5035 199.45 37.7641C196.575 31.0246 188.309 18.5572 178.016 13.7439C167.722 8.93056 164.451 6.01417 153.607 7.81808C142.764 9.622 129.129 18.2182 122.292 34.1865C115.455 50.1549 113.419 104.281 113.419 104.281Z"
        fill={activeColor}
        stroke={activeColor}
        strokeWidth="3px"
        style={{ opacity: value }}
      />
    </>
  );
}

L2Button.propTypes = {
  activeColor: PropTypes.string,
  color: PropTypes.string,
  value: PropTypes.number,
};

L2Button.defaultProps = {
  activeColor: '#FFFFFF',
  color: '#1A1A21',
  value: 0,
};

export default L2Button;
